export enum IconName {
  COMMENT = "COMMENT",
  CONDITION = "CONDITION",
  CONSTRUCTION_KIT = "CONSTRUCTION_KIT",
  FILTER = "FILTER",
  MARKETING_RULE = "MARKETING_RULE",
  MARK_1 = "MARK_1",
  MARK_2 = "MARK_2",
  MASTER_SHEET = "MASTER_SHEET",
  TAG = "TAG",
  TRANSFORMATION = "TRANSFORMATION",
  TRIGGER = "TRIGGER",
  BLANK = "BLANK",
  FOLDER = "FOLDER",
  PARTLIST_ENTRY = "PARTLIST_ENTRY",
  GEOMETRY = "GEOMETRY",
  PART = "PART",
  UNKNOWN = "UNKNOWN",
}
